import { useDevice } from 'device'
import links from 'links'
import { usePathname } from 'router'

import type { HeroSectionProps } from 'pages/landing/View/components/HeroSection/HeroSection'

import bouqsLogo from '../images/bouqsLogo.png'
import andreDrummondHeroMobileBackground from '../images/andre-drummond-hero-mobile.jpg?src-loader&size'
import andreDrummondHeroDesktopBackground from '../images/andre-drummond-hero-desktop.jpg?src-loader&size'
import andreDrummondHeroWithCaseMobileBackground from '../images/andre-drummond-hero-with-case-mobile.jpg?src-loader&size'
import andreDrummondHeroWithCaseDesktopBackground from '../images/andre-drummond-hero-with-case-desktop.jpg?src-loader&size'

import messages from './messages'


type CustomBlocksCreatorParams = {
  isMobile: boolean
  pathname: string
  price: string
  priceWithDiscount: string
  offerType: SubscriptionModule.OfferType
}

const getCustomBlocksByPathname = (props: CustomBlocksCreatorParams): HeroSectionProps['customBlocks'] | null => {
  const { pathname, isMobile, price, priceWithDiscount, offerType } = props
  if (pathname === links.nift) {
    return {
      title: {
        message: messages.nift.title,
        style: isMobile ? 'h4' : 'h2',
      },
      text: {
        message: messages.nift.text,
        style: isMobile ? 'p2' : 'sh4',
      },
      note: {
        message: messages.nift.note,
        style: isMobile ? 'p2' : 'sh6',
      },
    }
  }

  if (pathname === links.bouqs) {
    return {
      title: {
        message: messages.bouqs.title,
        style: isMobile ? 'h4' : 'h2',
      },
      text: {
        message: messages.bouqs.text,
        style: isMobile ? 'p2' : 'sh4',
      },
      note: {
        message: messages.bouqs.note,
        style: isMobile ? 'p2' : 'sh6',
      },
      timer: {
        withLabel: false,
      },
      logo: bouqsLogo,
    }
  }

  if (pathname === links.andreDrummond) {
    const buttonMessage = priceWithDiscount ? messages.andreDrummond.buttonWithDiscount : messages.andreDrummond.button
    return {
      title: {
        message: messages.andreDrummond.title,
        style: isMobile ? 'h4' : 'h2',
        color: 'gold-30',
      },
      text: {
        className: isMobile ? 'mt-8' : 'mt-24 max-w-464 font-normal',
        message: {
          ...messages.andreDrummond.text,
          values: {
            price,
            priceWithDiscount,
            afterTextStyle: priceWithDiscount ? (!isMobile && 'font-bold') : 'hidden',
          },
        },
        style: isMobile ? 'p2' : 'sh3',
        color: 'white',
      },
      timer: {
        withLabel: true,
        titleColor: 'gold-30',
        captionColor: 'gold-30',
        backgroundColor: 'gold-70',
        countdownColor: 'white',
      },
      button: {
        style: 'gold-30',
        actionType: 'quiz',
        title: {
          ...buttonMessage,
          values: {
            price,
            priceWithDiscount,
          },
        },
      },
      background: offerType
        ? isMobile ? andreDrummondHeroWithCaseMobileBackground : andreDrummondHeroWithCaseDesktopBackground
        : isMobile ? andreDrummondHeroMobileBackground : andreDrummondHeroDesktopBackground,
    }
  }

  return null
}

const useLandingCustomHeroBlocks = (props: Pick<CustomBlocksCreatorParams, 'offerType' | 'price' | 'priceWithDiscount'>) => {
  const pathname = usePathname()
  const { isMobile } = useDevice()

  return getCustomBlocksByPathname({ pathname, isMobile, ...props })
}


export default useLandingCustomHeroBlocks
